import React, { FC, ReactElement, useEffect, useState } from 'react';
import styles from './styles.module.css';
import { Asset } from '../Asset';
import { motion, AnimatePresence } from 'framer-motion';
import classNames from 'classnames';

type ExpansionPanelType = {
  head: ReactElement;
  id?: string;
  disabled?: boolean;
  open?: boolean;
  children?: React.ReactNode;
  className?: string;
};

export const ExpansionPanel: FC<ExpansionPanelType> = ({
  children,
  head,
  id,
  disabled,
  open,
  className,
}) => {
  const [isOpen, toggleOpen] = useState(open ?? false);

  useEffect(
    () => {
      if (open !== isOpen) {
        toggleOpen(open ?? false);
      }
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    /* disabled because we only want to react to changes from incoming `open`, not internal state */
    [open]
  );

  return (
    <div className={className?.trim() || styles.container} data-testid={id}>
      <div
        className={classNames(
          styles.title,
          disabled ? styles.disabled : styles.enabled
        )}
        onClick={() => (disabled ? false : toggleOpen(!isOpen))}
      >
        {head}
        <motion.div
          hidden={disabled}
          initial={false}
          exit="exit"
          animate={{
            transition: { ease: 'easeIn' },
            rotate: isOpen ? 180 : 0,
          }}
        >
          <Asset variant="upArrow" />
        </motion.div>
      </div>
      <AnimatePresence initial={false}>
        {isOpen && !disabled && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: {
                opacity: 1,
                height: 'auto',
                transition: { ease: 'easeIn' },
              },
              collapsed: {
                opacity: 0,
                height: 0,
                transition: { ease: 'easeOut' },
              },
            }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
